import type { FC } from 'react';
import { Stack, Switch, Typography } from '@mui/material';
import type { FeatureFlag } from '@pflegenavi/shared/api';
import {
  featureFlagDescriptions,
  FeatureFlagStatus,
} from '@pflegenavi/shared/api';
import {
  useFeatureFlag,
  useSetFeatureFlag,
} from '@pflegenavi/frontend/feature-flags';

interface FeatureFlagRowProps {
  featureFlag: FeatureFlag;
  inheritedFromTenant: boolean;
}

export const FeatureFlagRow: FC<FeatureFlagRowProps> = ({
  featureFlag,
  inheritedFromTenant,
}) => {
  const featureFlagEnabled =
    useFeatureFlag(featureFlag) === FeatureFlagStatus.Enabled;
  const setFeatureFlag = useSetFeatureFlag();

  return (
    <Stack
      direction="row"
      sx={{
        gap: 1,
        alignItems: 'flex-start',
        justifyContent: 'space-between',
      }}
    >
      <Stack>
        <Typography variant="subtitle2">
          {featureFlag}
          {inheritedFromTenant && ' (inherited from tenant)'}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
          }}
        >
          {featureFlagDescriptions[featureFlag]}
        </Typography>
      </Stack>
      <Switch
        checked={featureFlagEnabled}
        disabled={inheritedFromTenant}
        onChange={(_event, checked) => {
          setFeatureFlag(
            featureFlag,
            checked ? FeatureFlagStatus.Enabled : FeatureFlagStatus.Disabled
          );
        }}
      />
    </Stack>
  );
};
